import { loadStripe } from '@stripe/stripe-js';
import type { Stripe } from '@stripe/stripe-js';

const env = (
  import.meta as ImportMeta & { env?: Record<string, string | undefined> }
).env ?? {};

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripePromise(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(env.VITE_STRIPE_PUBLISHABLE_KEY ?? '');
  }
  return stripePromise;
}

export function resetStripePromise(): void {
  stripePromise = null;
}
